import React from "react";
import "./contactus.css";
import ApartmentIcon from '@mui/icons-material/Apartment';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import WifiCalling3Icon from '@mui/icons-material/WifiCalling3';
import BusinessIcon from '@mui/icons-material/Business';

import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";

const ContactUs = () => {
 

  return (
    <>
      <Header />

      <div className="container-fluid">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 pt_20 mt_30">
              <div className="heading_common mt_15">
                <h3>We're always eager to hear from you!</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row">
            <div className="col-lg-12 mt_15">
              <div className="mt_15">
                <p>
                  You can call us during working hours or visit our office. All
                  emails will get a response within 24 hours. We love to hear
                  from you!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
        <div className="container_box">
          <div className="contact-info">
            <h4 className="color_white">Contact Info</h4>

             <div className="d_flex align_center gap_10">
               <ApartmentIcon />
                <p> KTMEDU Mark Shopping Centre LLP </p>
                </div>
                <div>
                  <span> Offline Stores </span>
                    <div className="d_flex align_center gap_10">
                        <BusinessIcon /> 
                        <p> Dwarka Sector 15 South West Delhi, 110078 India </p>
                    </div>
                    </div>
                 <div>
                   <span> Offline Store </span>
                  <div className="d_flex align_center gap_10">
                    <BusinessIcon /> 
                      <p> Khair, Palwal Aligarsh Road Uttar Pradesh 201038 </p>
                  </div>
                 </div>
                 <div>
                  <span> Factory  Address</span>
                   <div className="d_flex align_center gap_10">
                    <BusinessIcon /> 
                    <p> Khair, Palwal Aligarsh Road Uttar Pradesh 201038 </p>
                  </div>
                 </div>
            <div className="d_flex align_center gap_10">
             <MailOutlineIcon />
               <p> ktmedumarkservices@gmail.com </p>
              </div> 
            {/* <div className="d_flex align_center gap_10">
             <PhoneIphoneIcon /> 
              <p>  WhatsApp No. : +918383060961</p>
            </div>
            <div className="d_flex align_center gap_10">
             <WifiCalling3Icon /> 
              <p>   Office No. : 01141051501 </p>
            </div> */}
          </div>

          <div className="form-section">
            <h4 className="text-center">Send a Message</h4>
            <form>
                <div class="inputSection">
                    <input className="userName" type="text" name="email" />
                    <label className="inputLabel">Name</label>
                    </div>
                    <div className="inputSection"><input className="password" type="password" value="" name="password" />
                    <label className="inputLabel">Email</label>
                    </div>
                    <div className="inputSection">
                        <input className="password" type="textarea" cols="10" value="" name="" />
                    <label className="inputLabel">Message</label>
                    </div>
                    <div className="text_right">
                    <button className="saveForm" type="submit">Save</button>
                    </div>
                    </form>
            
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
            <div className="col-lg-12">
                <div className="map_section">
            <iframe loading="lazy" src="https://maps.google.com/maps?q=133%2C%203rd%20Floor%20Shiv%20Park%20Purana%20Palam%20Road%20Dwarka-15%20South-West-Delhi%20New%20Delhi%2011007&#038;t=m&#038;z=10&#038;output=embed&#038;iwloc=near"
					title="133, 3rd Floor Shiv Park Purana Palam Road Dwarka-15 South-West-Delhi New Delhi 11007"
					aria-label="133, 3rd Floor Shiv Park Purana Palam Road Dwarka-15 South-West-Delhi New Delhi 11007"
			></iframe>
            </div>
            </div>
        </div>
      </div>
      </div>
      <Subscribe />
      <Footer />
    </>
  );
};

export default ContactUs;
